import { useEffect, useState } from "react";
import { Users, MousePointerClick, Euro, Coins, Download, CheckCircle2, TrendingUp } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminReferrals() {
  const [data, setData] = useState(null);

  const load = () => api.get("/admin/referral/overview").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const exportCsv = async () => {
    try {
      const r = await api.get("/admin/referral/payouts.csv", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement("a");
      a.href = url; a.download = "oxo_referral_payouts.csv"; a.click();
      window.URL.revokeObjectURL(url);
    } catch { toast.error("Eroare la export."); }
  };

  const markPaid = async (referrer_id) => {
    try { await api.post("/admin/referral/mark-paid", { referrer_id }); toast.success("Marcat ca plătit."); load(); }
    catch { toast.error("Eroare."); }
  };

  if (!data) return null;
  const cards = [
    { icon: MousePointerClick, label: "Total click-uri", value: data.total_clicks },
    { icon: Users, label: "Conversii (înregistrări)", value: data.total_conversions },
    { icon: Euro, label: "Comisioane în așteptare", value: `€${data.total_pending_eur}` },
    { icon: CheckCircle2, label: "Comisioane plătite", value: `€${data.total_paid_eur}` },
  ];

  return (
    <div data-testid="admin-referrals">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-black text-xl flex items-center gap-2"><TrendingUp className="w-5 h-5 text-orange-600" /> Parteneri & Comisioane</h2>
        <button onClick={exportCsv} className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-700 text-white px-4 py-2 text-sm font-bold uppercase tracking-wide transition-colors" data-testid="export-payouts-csv">
          <Download className="w-4 h-4" /> Export Payouts CSV
        </button>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {cards.map((c) => (
          <div key={c.label} className="border border-slate-200 p-4">
            <c.icon className="w-5 h-5 text-slate-400" />
            <div className="text-2xl font-black mt-2">{c.value}</div>
            <div className="text-[11px] uppercase tracking-wide text-slate-500 mt-0.5">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-100 text-[11px] uppercase tracking-wide text-slate-500">
            <tr>
              <th className="text-left px-3 py-2">Partener</th>
              <th className="text-right px-3 py-2">Click-uri</th>
              <th className="text-right px-3 py-2">Înregistrări</th>
              <th className="text-right px-3 py-2">Comisioane</th>
              <th className="text-right px-3 py-2">În așteptare</th>
              <th className="text-right px-3 py-2">Plătit</th>
              <th className="text-right px-3 py-2">Tokeni</th>
              <th className="px-3 py-2"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {data.top_referrers.length === 0 ? (
              <tr><td colSpan={8} className="px-3 py-6 text-center text-slate-400">Încă niciun partener activ.</td></tr>
            ) : data.top_referrers.map((r) => (
              <tr key={r.referrer_id} data-testid={`referrer-row-${r.ref_code}`}>
                <td className="px-3 py-2"><div className="font-semibold text-slate-900">{r.email}</div><div className="text-xs font-mono text-slate-400">{r.ref_code}</div></td>
                <td className="text-right px-3 py-2">{r.clicks}</td>
                <td className="text-right px-3 py-2">{r.registered}</td>
                <td className="text-right px-3 py-2">{r.conversions}</td>
                <td className="text-right px-3 py-2 font-bold text-orange-600">€{r.pending_eur}</td>
                <td className="text-right px-3 py-2 text-emerald-700">€{r.paid_eur}</td>
                <td className="text-right px-3 py-2 flex items-center justify-end gap-1"><Coins className="w-3.5 h-3.5 text-amber-500" />{r.tokens}</td>
                <td className="text-right px-3 py-2">
                  {r.pending_eur > 0 && (
                    <button onClick={() => markPaid(r.referrer_id)} className="text-xs font-bold uppercase text-emerald-700 hover:underline" data-testid={`mark-paid-${r.ref_code}`}>Marchează plătit</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
